import React, { Component } from "react";
import { connect } from "react-redux";
import { setActivity } from "../../widgets/DashboardComponents/V3/ActivityLogWidget/actions";

import SecurityModal from "../../pages/Components/SecurityModal/SecurityModal";
import {
    Card,
    CardHeader,
    CardContent,
    Button,
    Typography,
    TextField,
    Select,
    MenuItem,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { selectReport, canUpdate } from "./selectors";
import { getReport, setReport, getJobPackReports } from "./actions";
import { gridStyle, cellStyle } from "../gridHelper";

import data from "./data.json";

import { noImg } from "vrcore-dashboard/dist/utilities";
import ReactToPrint from "react-to-print";

import "../reports.css";

import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import styled from "styled-components";
const ActionButton = styled(Button)`
    @media print {
        visibility: hidden;
    }
`;
let checkedit = "";

class TrailerVehicleReport extends Component {
    constructor(props) {
        super(props);
        let path = props.location.pathname.split("/");
        checkedit = path[1];

        this.state = {
            imageModal: false,
            selectedImg: false,
            report: false,
            editing:
                path[1] === "report-view"
                    ? false
                    : path[1] === "report-view-standalone"
                    ? false
                    : true,
            title: document.title,
            reportType: path[4].replace(/-/g, "_"),
            checks: data,
        };
        if (path[2] === "reports") {
            props.getReport(
                props.match.params.uid,
                props.match.params.subject_name.replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":"),
                path[4].replace(/-/g, "_")
            );
        } else {
            props.getJobPackReports(
                props.match.params.uid,
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                path[7].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":")
            );
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.report !== prevProps.report) {
            this.setState({ report: this.props.report });
        }
    }
    renderText = (key, value) => {
        if (this.state.editing) {
            return (
                <TextField
                    value={this.state.report[key]}
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                />
            );
        } else {
            return value;
        }
    };
    renderTick = (key, value = false) => {
        if (this.state.editing) {
            return (
                <Select
                    value={
                        this.state.report[key] === undefined
                            ? false
                            : this.state.report[key]
                    }
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                    style={{ minWidth: "100%" }}
                >
                    <MenuItem value={"Acceptable"}>Acceptable</MenuItem>
                    <MenuItem value={"Un-Driveable"}>Un-Driveable</MenuItem>
                </Select>
            );
        } else {
            return value;
        }
    };

    render() {
        //let report = this.props.report === false ? false : this.props.report;
        let rT = this.renderText;
        let rTi = this.renderTick;

        let gstyle = gridStyle;
        let cstyle = cellStyle;

        const { editing, checks, report, selectedImg } = this.state;
        return editing && !this.props.canUpdate ? (
            <SecurityModal
                errType={"Update"}
                errPage={"Block Vehicle Check Report"}
                history={this.props.history}
            />
        ) : (
            <Card>
                <CardHeader title={"Trailer Check Sheet Report"} />
                <CardContent>
                    <ReactToPrint
                        onBeforePrint={() => {
                            setTimeout(undefined, 2000);
                            document.title =
                                "Trailer Check Sheet - " +
                                this.props.match.params.report_id
                                    .replace(/_/g, " ")
                                    .replace(/\./g, ":");
                        }}
                        onAfterPrint={() => {
                            document.title = this.state.title;
                        }}
                        trigger={() => (
                            <Button
                                style={{
                                    fontSize: "30px",
                                    marginBottom: "10px",
                                }}
                                color="primary"
                                variant="contained"
                            >
                                Print
                            </Button>
                        )}
                        content={() => this.componentRef}
                    />
                    {report && (
                        <>
                            <div ref={(el) => (this.componentRef = el)}>
                                {this.props.header && <this.props.header />}
                                <div
                                    className="imgDiv"
                                    style={{
                                        float: "left",
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <Typography variant="h5">
                                        Block Vehicle Check Report
                                    </Typography>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div
                                        style={gstyle(10, 13)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Report Details</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 7)}>
                                            <b>Document Ref:</b>
                                        </div>
                                        <div style={cstyle(2, 4, 2, 7, true)}>
                                            V-005a REV 1
                                        </div>
                                        <div style={cstyle(2, 7, 2, 13)}>
                                            <b>Timestamp</b>
                                        </div>
                                        <div style={cstyle(2, 10, 2, 13, true)}>
                                            {report.timestamp}
                                        </div>
                                        <div style={cstyle(3, 1, 3, 7)}>
                                            <b>Registration:</b>
                                        </div>
                                        <div style={cstyle(3, 4, 3, 7, true)}>
                                            {report.vehicle_reg
                                                ? report.vehicle_reg
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(3, 7, 3, 13)}>
                                            <b>Mileage</b>
                                        </div>
                                        <div style={cstyle(3, 10, 3, 13, true)}>
                                            {report.vehicle_mileage
                                                ? report.vehicle_mileage
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(4, 1, 4, 7)}>
                                            <b>Make:</b>
                                        </div>
                                        <div style={cstyle(4, 4, 4, 7, true)}>
                                            {report.vehicle_make
                                                ? report.vehicle_make
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(4, 7, 4, 13)}>
                                            <b>Model:</b>
                                        </div>
                                        <div style={cstyle(4, 10, 4, 13, true)}>
                                            {report.vehicle_model
                                                ? report.vehicle_model
                                                : "N/A"}
                                        </div>
                                    </div>
                                </div>
                                {Object.keys(checks).map((e) => {
                                    let checkRowCount = 2;

                                    return (
                                        <div
                                            style={{
                                                width: "100%",
                                                clear: "both",
                                            }}
                                        >
                                            <div
                                                style={gstyle(
                                                    checks[e].length + 3,
                                                    6,
                                                    null
                                                )}
                                            >
                                                <div
                                                    style={cstyle(
                                                        1,
                                                        1,
                                                        1,
                                                        4,
                                                        false,
                                                        true
                                                    )}
                                                >
                                                    <b>{e}</b>
                                                </div>
                                                <div
                                                    style={cstyle(
                                                        1,
                                                        4,
                                                        1,
                                                        6,
                                                        false,
                                                        true
                                                    )}
                                                >
                                                    <b>Signed Off</b>
                                                </div>
                                                <div
                                                    style={cstyle(
                                                        2,
                                                        1,
                                                        2,
                                                        1,
                                                        false
                                                    )}
                                                >
                                                    <b>Item</b>
                                                </div>
                                                <div
                                                    style={cstyle(
                                                        2,
                                                        2,
                                                        2,
                                                        3,
                                                        false
                                                    )}
                                                >
                                                    <b>OK?</b>
                                                </div>
                                                <div
                                                    style={cstyle(
                                                        2,
                                                        3,
                                                        2,
                                                        4,
                                                        false
                                                    )}
                                                >
                                                    <b>Defect/Comments</b>
                                                </div>
                                                <div
                                                    style={cstyle(
                                                        2,
                                                        4,
                                                        2,
                                                        5,
                                                        false
                                                    )}
                                                >
                                                    <b>By</b>
                                                </div>
                                                <div
                                                    style={cstyle(
                                                        2,
                                                        5,
                                                        2,
                                                        6,
                                                        false
                                                    )}
                                                >
                                                    <b>Date</b>
                                                </div>
                                                {checks[e].map((f) => {
                                                    checkRowCount++;

                                                    return (
                                                        <React.Fragment
                                                            key={checkRowCount}
                                                        >
                                                            <div
                                                                style={cellStyle(
                                                                    checkRowCount,
                                                                    1,
                                                                    checkRowCount,
                                                                    2
                                                                )}
                                                            >
                                                                {f.question}
                                                            </div>
                                                            <div
                                                                style={cellStyle(
                                                                    checkRowCount,
                                                                    2,
                                                                    checkRowCount,
                                                                    3
                                                                )}
                                                            >
                                                                {rTi(
                                                                    f.check,
                                                                    report[
                                                                        f.check
                                                                    ]
                                                                )}
                                                            </div>
                                                            <div
                                                                style={cellStyle(
                                                                    checkRowCount,
                                                                    3,
                                                                    checkRowCount,
                                                                    4,
                                                                    true
                                                                )}
                                                            >
                                                                {rT(
                                                                    f.defect,
                                                                    report[
                                                                        f.defect
                                                                    ]
                                                                )}
                                                            </div>
                                                            <div
                                                                style={cellStyle(
                                                                    checkRowCount,
                                                                    4,
                                                                    checkRowCount,
                                                                    5,
                                                                    true
                                                                )}
                                                            >
                                                                {rT(
                                                                    f.by,
                                                                    report[f.by]
                                                                )}
                                                            </div>
                                                            <div
                                                                style={cellStyle(
                                                                    checkRowCount,
                                                                    5,
                                                                    checkRowCount,
                                                                    6,
                                                                    true
                                                                )}
                                                            >
                                                                {rT(
                                                                    f.date,
                                                                    report[
                                                                        f.date
                                                                    ]
                                                                )}
                                                            </div>
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    );
                                })}
                                <div style={{ width: "100%" }}>
                                    <div style={gstyle(3, 13)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Other Comments</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 13, true)}>
                                            {report.other_comments
                                                ? report.other_comments
                                                : "N/A"}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div style={gstyle(10, 13)}>
                                        <div style={cstyle(1, 1, 1, 7)}>
                                            <b>Date:</b>
                                        </div>
                                        <div style={cstyle(1, 4, 1, 7, true)}>
                                            {report.date ? report.date : "N/A"}
                                        </div>
                                        <div style={cstyle(2, 1, 2, 7)}>
                                            <b>Time:</b>
                                        </div>
                                        <div style={cstyle(2, 4, 2, 7, true)}>
                                            {report.time ? report.time : "N/A"}
                                        </div>
                                        <div style={cstyle(3, 1, 3, 7)}>
                                            <b>Carried out by(print):</b>
                                        </div>
                                        <div style={cstyle(3, 4, 3, 7, true)}>
                                            {report.user_name
                                                ? report.user_name
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(4, 1, 4, 7)}>
                                            <b>Position:</b>
                                        </div>
                                        <div style={cstyle(4, 4, 4, 7)}>
                                            {report.position
                                                ? report.position
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(1, 7, 5, 13, true)}>
                                            <img
                                                src={
                                                    report.recorder_sig_url ===
                                                        undefined ||
                                                    report.recorder_sig_url ===
                                                        null ||
                                                    report.recorder_sig_url ===
                                                        ""
                                                        ? noImg
                                                        : report.recorder_sig_url
                                                }
                                                alt="Signature"
                                                style={{
                                                    width: "auto",
                                                    minHeight: "100%",
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        {this.state.editing &&
                            checkedit === "report-edit-jobpack" && (
                                <Link
                                    to={this.props.location.pathname.replace(
                                        "report-edit-jobpack",
                                        "report-view"
                                    )}
                                >
                                    <div>
                                        <ActionButton
                                            style={{ marginRight: 10 }}
                                            onClick={() => {
                                                this.props.setReport(
                                                    this.state.report,
                                                    this.props.location.pathname
                                                );
                                                this.props.setActivity(
                                                    "update",
                                                    "report",
                                                    this.state.reportType
                                                );
                                            }}
                                            variant="contained"
                                            color="primary"
                                        >
                                            Submit
                                        </ActionButton>
                                        <ActionButton
                                            color="secondary"
                                            variant="contained"
                                        >
                                            Cancel
                                        </ActionButton>
                                    </div>
                                </Link>
                            )}

                        {!this.state.editing && checkedit === "report-view" && (
                            <Link
                                to={this.props.location.pathname.replace(
                                    "report-view",
                                    "report-edit-jobpack"
                                )}
                            >
                                <ActionButton
                                    variant="contained"
                                    color="primary"
                                >
                                    Edit
                                </ActionButton>
                            </Link>
                        )}
                    </div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        {this.state.editing && checkedit === "report-edit" && (
                            <Link
                                to={this.props.location.pathname.replace(
                                    "report-edit",
                                    "report-view-standalone"
                                )}
                            >
                                <div>
                                    <ActionButton
                                        style={{ marginRight: 10 }}
                                        onClick={() => {
                                            this.props.setReport(
                                                this.state.report,
                                                this.props.location.pathname
                                            );
                                            this.props.setActivity(
                                                "update",
                                                "report",
                                                this.state.reportType
                                            );
                                        }}
                                        variant="contained"
                                        color="primary"
                                    >
                                        Submit
                                    </ActionButton>
                                    <ActionButton
                                        color="secondary"
                                        variant="contained"
                                    >
                                        Cancel
                                    </ActionButton>
                                </div>
                            </Link>
                        )}

                        {!this.state.editing &&
                            checkedit === "report-view-standalone" && (
                                <Link
                                    to={this.props.location.pathname.replace(
                                        "report-view-standalone",
                                        "report-edit"
                                    )}
                                >
                                    <ActionButton
                                        variant="contained"
                                        color="primary"
                                    >
                                        Edit
                                    </ActionButton>
                                </Link>
                            )}
                    </div>
                    {/* {this.state.editing && (
                        <Link
                            to={this.props.location.pathname.replace(
                                "report-edit",
                                "report-view"
                            )}
                        >
                            <div>
                                <Button
                                    style={{ marginRight: 10 }}
                                    onClick={() => {
                                        this.props.setReport(
                                            this.state.report,
                                            this.props.location.pathname,
                                            reportType
                                        );
                                    }}
                                    variant="contained"
                                >
                                    Submit
                                </Button>
                                <Button color="primary" variant="contained">
                                    Cancel
                                </Button>
                            </div>
                        </Link>
                    )}
                    {!this.state.editing && (
                        <Link
                            to={this.props.location.pathname.replace(
                                "report-view",
                                "report-edit"
                            )}
                        >
                            <Button variant="contained">Edit</Button>
                        </Link>
                    )} */}
                    {report && (
                        <Modal isOpen={this.state.imageModal}>
                            <ModalHeader>Additional Notes Image</ModalHeader>
                            <ModalBody style={{ margin: "auto" }}>
                                <img
                                    src={
                                        selectedImg === undefined ||
                                        selectedImg === null ||
                                        selectedImg === ""
                                            ? noImg
                                            : selectedImg
                                    }
                                    alt="Site"
                                    style={{ width: "350px", height: "350px" }}
                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        this.setState({
                                            selectedImg: false,
                                            imageModal: false,
                                        });
                                    }}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                    )}
                </CardContent>
            </Card>
        );
    }
}
export default connect(
    (store) => {
        return { report: selectReport(store), canUpdate: canUpdate(store) };
    },
    { getReport, setReport, setActivity, getJobPackReports }
)(TrailerVehicleReport);
